import React, { useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";
import axios from "axios";
import { environment } from "../../env";
import { Label } from "reactstrap";
import ErrorComponents from "../errorComponents/ErrorComponents";
import { useDispatch, useSelector } from "react-redux";
import { loaderAction, successModalToggle } from "../../redux/actions/Index";
import { useMemo } from "react";
import { useEffect } from "react";
import { ToWords } from 'to-words';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash';
import Table from './../Table';
import moment from 'moment'
import EmptyTable from "../errorComponents/EmptyTable";
import { getSoldGalaAction } from './../../redux/actions/Index';


function ResellGalasModal({ update, galaSoldHandeler }, props) {
  const toWords = new ToWords();

  // ---------List of useState-------------------------------------------------------
  const [modal, setModal] = useState(false);
  const [btndis, setBtndis] = useState(false);
  const [investordata, setInvestorData] = useState([]);
  const [Investors, setInvestors] = useState([]);
  const [show, setShow] = useState(false)
  const [selectedProperty, setSelectedProperty] = useState()
  const [areaerr, setAreaerr] = useState('');
  // const [resellError, setresellError] = useState();
  const [resellState, setresellState] = useState();
  const [err, setErr] = useState();
  const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
  // --------------------------------------------------------------------------------
  const soldGalaLists = useSelector((state) => state?.ModalReducer?.soldGalaList);
  const reasonList = useSelector((state) => state?.ModalReducer?.reasonList);
  var projectList = useSelector((state) => state?.ModalReducer?.projectList);
  projectList = projectList?.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
  var buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  buildingList = buildingList?.sort((a, b) => (a.building_no > b.building_no) ? 1 : ((b.building_no > a.building_no) ? -1 : 0))
  const investortype = useSelector((state) => state?.ModalReducer?.investortype);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);


  const [filteredGalaList, setFilteredGalaList] = useState([]);
  const [filterBuilding, setFilterBuilding] = useState();
  const [filtergalas, setFiltergalas] = useState([]);
  const [investorList, setInvestorList] = useState([]);
  const [investorNumber, setInvestorNumber] = useState([]);
  const [investorTypes, setInvestorTypes] = useState([]);

  const dispatch = useDispatch();
  const toggle = () => { setModal(!modal); setShow(false); setSelectedProperty(); }
  let total = 0

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  var oldI = watch('Investors')
  var area = watch('sold_gala_area')
  var selectedGalaBuiltupAreaId = watch("gala");
  var selectedSoldGalaBuiltupArea = watch("sold_gala_area");
  var selectedProject = watch('project');
  var selectedBuilding = watch('building');
  var selectedGala = watch('gala');
  var selectedtype = watch('ownertype');
  var selectednumber = watch('joined_investor')
  var count = watch('hidden')

  useMemo(() => {
    if (selectedProperty != undefined) {
      if ((selectedProperty.sold_gala_area - selectedProperty.resell_area) < area) {
        setErr('Entered Resell Area is greater than selected area')
      } else {
        setErr('')
      }
    }
  }, [area])


  const GetInverster = async (gala) => {
      dispatch(loaderAction())
      if(userProject != undefined){
        const GetInvesterURL = `${environment.baseUrl}sold-gala-investor-filter/?gala=${gala == undefined ? "" :gala}&project=${userProject == undefined? "" : userProject}&building=${selectedProperty?.building?.building_no}`;
        try {
          var newInvestorList = [];
          await axios.get(GetInvesterURL).then((investorResponse) => {
            dispatch(loaderAction())
            investorResponse.data.map((investorsList) => {
              if(selectedProperty.Investors.id != investorsList.id){
                newInvestorList.push({ label: `${investorsList.name} B:${investorsList.building.building_no} G:${investorsList.gala.gala_no}`, value: investorsList.id })
              }
            })
          })
          setInvestorList(newInvestorList);
        }
        catch (err) {
          dispatch(loaderAction())
        }
      }
  }

  useMemo(() => {
    if(selectedProperty != undefined){
      GetInverster(selectedProperty.gala.id)
    }
  }, [selectedProperty])

  const filterGala = async (project, building) => {
    var galaList = []
    if (project == undefined || building == undefined) {
      return
    }
    // --- building and project gala details code starts here ---
    const FilterGalaPayload = new FormData();
    FilterGalaPayload.append('project', project);
    FilterGalaPayload.append('building', building);
    const FilterGalaURL = `${environment.baseUrl}filter-gala/`;
    await axios.post(FilterGalaURL, FilterGalaPayload).then((response) => {
      setFiltergalas(response.data.data)
      response.data.data.map((newgalalist) => {
        galaList.push({ label: newgalalist.gala_no, value: newgalalist.id })
      })
      setFilteredGalaList(galaList);
    })
  }

  const GalaArea = (e, number, edit) => {
    if (edit == false) {
      if (number < 0) {
        setValue(`available_area`, selectedProperty?.sold_gala_area - selectedProperty?.resell_area);
      } else {
        setValue(`available_area_${number}`, selectedProperty?.sold_gala_area - selectedProperty?.resell_area);
      }
    } else {
      setValue(`available_area_${number + 1}`, getValues(`available_area_${number}`) - e)
    }
  }
  const CheckArea = (e, number) => {
    e = Number(e).toFixed(2)
    if (number != undefined) {
      const area = getValues(`available_area_${number}`)
      if (Number(e) > Number(area)) {
        setAreaerr(`Sell Gala Area ${e} Is Greater than Available Area ${area}`)
      } else {
        setAreaerr()
      }
    }
    else {
      const area = getValues(`available_area`)
      if (Number(e) > Number(area)) {
        setAreaerr(`Sell Gala Area ${e} Is Greater than Available Area ${area}`)
      } else {
        setAreaerr()
      }
    }
  }

  useMemo(() => {
    let buildinglist = [];
    if (userProject) {
      var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
      projectBuilding?.map((building) => {
        buildinglist.push({ label: building.building_no, value: Number(building.id) })
      })
      setFilterBuilding(buildinglist)
    }
  }, [userProject])
  useMemo(() => {
    let investorTypeList = [];
    if (investortype) {
      investortype.map((investor) => {
        investorTypeList.push({ label: investor.investor_type, value: investor.id })
      })
    }
    setInvestorTypes(investorTypeList.reverse())
  }, [investortype]);
  useMemo(() => {
    if (userProject && selectedBuilding?.value) {
      filterGala(userProject, selectedBuilding?.value);
    }
  }, [userProject, selectedBuilding?.value, selectedBuilding]);
  useMemo(() => {
    if (selectedtype?.label == 'Join') {
      let i = 1;
      let arr = []
      if (selectednumber == undefined) {
        setValue('hidden', 1)
      }
      if (count <= selectednumber) {
        while (i < Number(count) + 1) {
          arr.push(i)
          i++;
        }
        setInvestorNumber(arr);
      }
      GalaArea({ 'label': 'asdasd', 'value': selectedProperty?.gala?.id }, 1, false)
    } else {
      GalaArea({ 'label': 'asdasd', 'value': selectedProperty?.gala?.id }, -2, false)
    }
  }, [selectednumber, selectedtype, count])

  const BuildingOptions = async (query) => {
    let filteredBuildings;
    const filteredBuildingURL = `${environment.baseUrl}filter-building/`;
    const FilterBuildingPayload = new FormData();
    FilterBuildingPayload.append('query', query);
    const result = await axios.post(filteredBuildingURL, FilterBuildingPayload).then((response) => {
      let filteredBuilding = [];
      response.data.map((BuildingList) => {
        filteredBuilding.push({ label: BuildingList.building_no, value: BuildingList.id })
      })
      filteredBuildings = filteredBuilding;
    })

    if (filteredBuildings.length > 0) {
      return filteredBuildings
    } else {
      return []
    }
  };

  const GalaOptions = async (query) => {
    let filteredGalas;
    const filteredGalaURL = `${environment.baseUrl}filter-gala-List/`;
    const FilterGalaPayload = new FormData();
    FilterGalaPayload.append('query', query);
    FilterGalaPayload.append('building', selectedBuilding?.value);
    FilterGalaPayload.append('project', userProject);
    const result = await axios.post(filteredGalaURL, FilterGalaPayload).then((response) => {
      let filteredGala = [];
      response.data.map((GalaList) => {
        filteredGala.push({ label: GalaList.gala_no, value: GalaList.id })
      })
      filteredGalas = filteredGala;
    })
    if (filteredGalas.length > 0) {
      return filteredGalas
    } else {
      return []
    }
  };

  const getInvestorProperties = (selected) => {
    dispatch(loaderAction())
    axios
      .get(`${environment.baseUrl}investor-properties/${selected}`)
      .then((res) => {
        setInvestors(res.data);
        setShow(true);
      })
      .catch((res) => {
        dispatch(loaderAction())
        console.log("error");
      });
  };

  const CancelButton = () => {
    setInvestors([])
    toggle();
    setBtndis(false)
    setInvestorNumber();
    reset();
  };

  useMemo(() => {
    if (oldI) {
      getInvestorProperties(oldI.value)
    }
  }, [oldI])

  const getSoldGalaData = () => {
    try {
      axios.get(`${environment.baseUrl}sold-gala/`).then(res => {
        dispatch(getSoldGalaAction(res.data));
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  const onSubmit = async (data) => {
    setBtndis(true);
    setresellState(data.sub_gala_name)
    dispatch(loaderAction())
    let arr = []
    let daata = 0;
    const SoldGalaPayloadsingle = new FormData();
    try {
      if (data.ownertype?.label == 'Self') {
        SoldGalaPayloadsingle.append('project', selectedProperty?.project?.id)
        SoldGalaPayloadsingle.append('building', selectedProperty?.building?.id)
        SoldGalaPayloadsingle.append('gala', selectedProperty?.gala?.id)
        SoldGalaPayloadsingle.append('Investors', data.Investors?.value)
        SoldGalaPayloadsingle.append('ownertype', 'Self')
        SoldGalaPayloadsingle.append('ownership', Number(selectedProperty.ownership) + 1)
        SoldGalaPayloadsingle.append('sold_gala_area', data.sold_gala_area)
        SoldGalaPayloadsingle.append('sub_gala_name', data.sub_gala_name)
        SoldGalaPayloadsingle.append('created_at', data?.created_at)
        SoldGalaPayloadsingle.append('old_investor', selectedProperty?.id)
        SoldGalaPayloadsingle.append('old_investor_sell_area', (Number(selectedProperty?.sold_gala_area) - Number(data.sold_gala_area)))
        SoldGalaPayloadsingle.append('old_investor_ownertype', selectedProperty?.ownertype)
        SoldGalaPayloadsingle.append('old_investor_sub_gala_name', selectedProperty?.sub_gala_name)
        SoldGalaPayloadsingle.append('old_investor_created_at', selectedProperty?.created_at)
        SoldGalaPayloadsingle.append('resell_reason', data?.resell_reason)
        SoldGalaPayloadsingle.append('comment', data?.comment)
      }
      else {
        for (let i = 1; i < Number(selectednumber) + 1; i++) {
          const SoldGalaPayload = new FormData();
          SoldGalaPayload.append('project', selectedProperty?.project?.id)
          SoldGalaPayload.append('building', selectedProperty?.building?.id)
          SoldGalaPayload.append('gala', selectedProperty?.gala?.id)
          SoldGalaPayload.append('created_at', data?.created_at)
          SoldGalaPayload.append('Investors', eval("data.Investors_" + i + "?.value"))
          SoldGalaPayload.append('ownertype', 'Joined')
          SoldGalaPayload.append('ownership', Number(selectedProperty.ownership) + 1)
          SoldGalaPayload.append('sold_gala_area', eval("data.sold_gala_area_" + i))
          SoldGalaPayload.append('sub_gala_name', eval("data.sub_gala_name_" + i))
          SoldGalaPayload.append('old_investor', selectedProperty?.id)
          SoldGalaPayload.append('old_investor_sell_area', (Number(selectedProperty?.sold_gala_area) - Number(eval("data.sold_gala_area_" + i))))
          SoldGalaPayload.append('old_investor_ownertype', selectedProperty?.ownertype)
          SoldGalaPayload.append('old_investor_sub_gala_name', selectedProperty?.sub_gala_name)
          SoldGalaPayload.append('old_investor_created_at', selectedProperty?.created_at)
          SoldGalaPayload.append('resell_reason', data?.resell_reason)
          SoldGalaPayload.append('comment', data?.comment)
          daata = Array.from(SoldGalaPayload.entries()).reduce((memo, [key, value]) => ({
            ...memo,
            [key]: value,
          }), {});
          arr.push(daata);
        }
      }
      console.log(arr)
      await axios.post(`${environment.baseUrl}resell-gala/`, data.ownertype?.label == 'Self' ? SoldGalaPayloadsingle : arr).then((soldgala) => {
        if (soldgala.data.code === 200) {
          dispatch(successModalToggle());
          dispatch(loaderAction())
          toggle();
          reset();
          galaSoldHandeler();
          setBtndis(false);
        }
      })
      setBtndis(false);
    }
    catch (err) {
      setBtndis(false);
      console.log(err);
    }
  };
  // useMemo(() => {
  //   if (!resellState) {
  //     setresellError("");
  //   }
  // }, [resellState])
  const getInvestorData = () => {
    axios.get(`${environment.baseUrl}investor/`).then(res => {
      let arr = []
      res.data.map(curElm => {
        arr.push({ label: `${curElm.name} B:${curElm.building.building_no} G:${curElm.gala.gala_no}`, value: curElm.id })
      })
      arr?.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
      setInvestorData(arr)
    })
      .catch(res => {
        console.log("error");
      })
  }

  useEffect(() => {
    // getInvestorData();
  }, [])

  useMemo(() => {
    let d = new Date()
    if (selectedProperty) {
      reset({ 'sub_gala_name': selectedProperty.sub_gala_name, 'created_at': moment(d).format('yyyy-MM-DD') })
    }
  }
    , [selectedProperty])

  const customSort = (a, b) => {
    const aIsNumber = !isNaN(Number(a.gala.gala_no));
    const bIsNumber = !isNaN(Number(b.gala.gala_no));
  
    if (aIsNumber && bIsNumber) {
      return Number(a.gala.gala_no) - Number(b.gala.gala_no);
    } else if (aIsNumber) {
      return -1;
    } else if (bIsNumber) {
      return 1;
    } else {
      return a.gala.gala_no.localeCompare(b.gala.gala_no);
    }
  }

  const InvestorOptions = async (query) => {
    let dd;
    const filteredInvestorURL = `${environment.baseUrl}filter-investor/`;
    const FilterInvestorPayload = new FormData();
    FilterInvestorPayload.append('query', query);
    FilterInvestorPayload.append('building', selectedProperty != undefined ? selectedProperty.building.id : "");
    FilterInvestorPayload.append('gala', "");
    let filteredInvesters = [];
    const result = await axios.post(filteredInvestorURL, FilterInvestorPayload).then((response) => {
      let curentProjectInvestor = [];
      if(response?.data?.length > 0){
        response.data.sort(customSort);
      }
      response.data.map(item => {
          if (item.building.project == userProject){
              curentProjectInvestor.push(item);
          }
      })
      curentProjectInvestor.map((invesrtorList) => {
        filteredInvesters.push({ label: `${invesrtorList.name} B:${invesrtorList.building.building_no} G:${invesrtorList.gala.gala_no}`, value: invesrtorList.id })
      })
    })

    if (filteredInvesters.length > 0) {
      return filteredInvesters
    } else {
      return []
    }
  };


  const columnns = [
    {
      name: 'Building',
      selector: row => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Gala',
      selector: row => row.gala?.gala_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Sub-Gala',
      selector: row => row.sub_gala_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Area Owns',
      selector: row => (row.sold_gala_area - row.resell_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Rent Area',
      selector: row => (row.rent_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Available Area',
      selector: row => Math.floor((row.sold_gala_area - row.resell_area) - row.rent_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    }
  ];

  const ordinal = (i) => {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }

  return (
    <>
      <Button
        onClick={toggle}
        className="border-radius-17  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5 py-4"

      >
        <span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">
          Resale Gala
        </span>
      </Button>
      <Modal
        className="border-0"
        isOpen={modal}
        toggle={props.toggle}
        size={Investors.length > 0 ? 'xl' : 'md'}
        centered
      >
        <ModalHeader className="bg-base-color ">
          <span className="title-font-700 fs-36 text-base-white">
            Resale Galas
          </span>
        </ModalHeader>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody className="bg-background-color px-5">
            <div className="row">
              {
                Investors.length > 0 &&
                <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                  <Label className="fs-4 title-font-500 mb-0 text-base-color opacity-0">
                    .
                  </Label>
                  <h1 className="fs-1 title-font-700 text-base-color pb-3">Old Investor Details</h1>
                </div>
              }

              <div className={Investors.length > 0 ? "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1" : "col-11 mx-auto  pb-3 pt-1"}>
                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                  Select Old Investor *
                </Label>
                <br />
                <div className="mt-1  d-flex gap-3">
                  <Controller
                    className="p-3 mb-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    control={control}
                    name="Investors"
                    render={({
                      field: { onChange },
                      fieldState: { isTouched, isDirty, error },
                      formState,
                    }) => (
                      <AsyncSelect placeholder="Type Investor Name" cacheOptions defaultOptions={investordata} loadOptions={InvestorOptions} onChange={onChange} className='w-100' />
                    )}
                  />
                </div>
                {errors.Investors && (
                  <ErrorComponents error={"Old Investors is required *"} />
                )}
                <br />
              </div>

              {show &&
                <div className="bg-white p-5 rounded-5 shadow-sm">
                  {Investors.length > 0 ? <Table columns={columnns} data={Investors} inves={true} resell={true} propertiesDetail={setSelectedProperty} /> : <h3 className="fs-3 text-center text-base-color base-font-600">No Data Found! 🤷‍♂️   </h3>}
                  {selectedProperty &&
                    <div className="card w-100 border-0 border-radius-15">
                      <h1 className="title-font-bold ms-3">Selected Property</h1>
                      <div className="row g-0 pb-4 text-start text-sm-start text-md-start text-lg-start text-xl-start">
                        <div className="col-12 col-lg-4 col-md-6  col-sm-6 col-xl-4   col-lg-6 mt-3">
                          <div className="card-body">
                            <h5 className="fs-3 base-font-700 mb-4">Project Name: <span className='fs-3 base-font-400'>{selectedProperty.project.name}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4 ">Sub Gala Name: <span className='fs-3 base-font-400'>{selectedProperty.sub_gala_name}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4 ">Ownership : <span className='fs-3 base-font-400'>{ordinal(selectedProperty.ownership)} Owner</span> </h5>
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-6  col-sm-6 col-xl-4 col-lg-6 mt-3">
                          <div className="card-body">
                            <h5 className="fs-3 base-font-700 mb-4">Building No: <span className='fs-3 base-font-400'>{selectedProperty.building.building_no}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Sub Gala Area: <span className='fs-3 base-font-400'>{selectedProperty.sold_gala_area - selectedProperty.resell_area} sqft</span> </h5>
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 col-md-12  col-sm-6 col-xl-4   col-lg-12 mt-3">
                          <div className="card-body">
                            <h5 className="fs-3 base-font-700 mb-4">Gala No: <span className='fs-3 base-font-400'>{selectedProperty.gala.gala_no}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Owner Type:<span className='fs-3 base-font-400'> {selectedProperty.ownertype}</span> </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  }</div>}
              {selectedProperty && <>
                <div className="row">
                  <hr className="my-4" />
                  <h2 className="fs-2 title-font-700 text-base-color pb-4">New Investor Details</h2>
                  {/* <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Building No *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <Controller
                          control={control}
                          name="building"
                          rules={{ required: true }}
                          render={({
                            field: { onChange },
                            fieldState: { isTouched, isDirty, error },
                            formState,
                          }) => (
                            <AsyncSelect placeholder="Search Building" cacheOptions defaultOptions={filterBuilding} loadOptions={BuildingOptions} className='w-100' onChange={onChange} />
                          )}
                        />
                      </div>
                      {errors.building && <ErrorComponents error={'building No is required *'} />}
                      <br />
                    </div>
                    <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Gala No *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <Controller
                          control={control}
                          name="gala"
                          rules={{ required: true }}
                          render={({
                            field: { onChange },
                            fieldState: { isTouched, isDirty, error },
                            formState,
                          }) => (
                            <AsyncSelect cacheOptions defaultOptions={filteredGalaList} loadOptions={GalaOptions}
                              onChange={
                                (e) => { onChange(e.value); GalaArea(e, -2, false); GetInverster(e.value) }
                              }
                              className='w-100' />
                          )}
                        />
                      </div>
                      {errors.gala && <ErrorComponents error={'Gala No is required *'} />}
                      <br />
                    </div> */}
                  <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0'>
                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                      Type for Sell
                    </Label>
                    <br />

                    <div className='mt-1  d-flex gap-3'>
                      <select
                        id="city"
                        name="city"
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        {...register("resell_reason", { required: true })}
                      >
                        <option value="">Select Reason</option>
                        {reasonList?.map((data, i) => {
                          return <option value={data.name} key={i}>{data.name}</option>;
                        })}
                      </select>
                    </div>
                    {errors.created_at && <ErrorComponents error={'Selling date is required *'} />}
                    <br />
                  </div>
                  <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                    <Label className="fs-4 title-font-500 mb-0 text-base-color">
                      Additional Comments
                    </Label>
                    <br />
                    <div className="mt-1  d-flex gap-3">
                      <textarea
                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                        minLength={0}
                        placeholder='Enter Additional Comments...'
                        {...register("comment")}
                      ></textarea>
                    </div>
                    <br />
                  </div>
                  <div className={`col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0`}>
                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                      Ownership Type *
                    </Label>
                    <br />
                    <div className='mt-1  d-flex gap-3'>
                      <Controller
                        control={control}
                        name="ownertype"
                        rules={{ required: true }}
                        render={({
                          field: { onChange },
                          fieldState: { isTouched, isDirty, error },
                          formState,
                        }) => (
                          <AsyncSelect placeholder="Investor type" cacheOptions defaultOptions={investorTypes} onChange={onChange} className='w-100' />
                        )}
                      />
                    </div>
                    {errors.ownertype && <ErrorComponents error={'Ownership Type is required *'} />}
                    <br />
                  </div>
                  <div className={`col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0`}>
                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                      Selling date
                    </Label>
                    <br />

                    <div className='mt-1  d-flex gap-3'>
                      <input
                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                        type='date'
                        {...register("created_at",
                          {
                            required: true
                            ,
                          })}
                      />
                    </div>
                    {errors.created_at && <ErrorComponents error={'Selling date is required *'} />}
                    <br />
                  </div>
                  {selectedtype?.label == 'Join' &&
                    <>
                      <div className={`col-11 mx-auto col-md-6 col-lg-6 col-xl-6  pb-3 pt-1  mx-md-0`}>
                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                          Joined Investors Number
                        </Label>
                        <br />
                        <div className='mt-1  d-flex gap-4'>
                          <input
                            className="p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input"
                            type="number"
                            min={0}
                            name="num"
                            disabled={(e) => { e.target.value == 1 }}
                            onChange={() => handleNumChange(e)}
                            placeholder="Enter Number of Investors"
                            {...register("joined_investor", {
                              required: true,
                            })}
                          />
                        </div>
                        {
                          selectednumber >= 10 &&
                          <h4 className="fs-4 text-base-black text-danger pt-3 ">Joined Investors Number is less than 10</h4>
                        }
                        {errors.joined_investor && <ErrorComponents error={'Investors Number is required *'} />}
                        <br />
                      </div>
                    </>}
                  {
                    total != 0 &&
                    <>
                      <input
                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                        type="text"
                        placeholder="hidden"
                        {...register("hidden")}
                      />
                    </>
                  }
                </div>
                {
                  selectedtype?.label == 'Self' ?
                    selectedtype?.label == 'Self' ?
                      <div className="bg-white py-2 px-3 rounded-5">
                        <div>
                          <div className={`${userProject !== undefined ? "col-12 pb-3 pt-2" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                            <editable-table>
                              <table className=''>
                                <thead className=''>
                                  <tr >
                                    <th className='fs-5 col-3 title-font-600 mb-0 text-base-color'>
                                      Select Investor
                                    </th>
                                    <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                      Available Area
                                    </th>
                                    <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                      Sold Area
                                    </th>
                                    <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                      Sub-Gala Name
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr >
                                    <th style={{ display: "contents" }}>
                                      <td className="pb-2 ps-2">
                                        <Controller
                                          className="p-3 mb-3 border-radius-10 shadow-none  w-100 fs-4 base-font-500 modal-input"
                                          control={control}
                                          name="Investors"
                                          rules={{ required: true }}
                                          render={({
                                            field: { onChange },
                                            fieldState: { isTouched, isDirty, error },
                                            formState,
                                          }) => (
                                            <AsyncSelect placeholder="Investor" cacheOptions defaultOptions={investorList} loadOptions={InvestorOptions} onChange={onChange} className='w-100' />
                                          )}
                                        />
                                      </td>
                                      <td className=' pb-2 ps-2 '>
                                        <input
                                          className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                          min="0"
                                          type="number"
                                          placeholder="Area...."
                                          disabled
                                          {...register(`available_area`)}
                                        />
                                      </td>
                                      <td className=' pb-2 ps-2 '>
                                        <input
                                          className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                          min="0"
                                          step="any"
                                          type="number"
                                          placeholder="Area...."
                                          {...register(`sold_gala_area`, {
                                            required: true,
                                            onChange: (e) => {
                                              CheckArea(e.target.value)
                                            }
                                          })}
                                        />
                                      </td>
                                      <td className="pb-2 ps-2">
                                        <div className='mt-1  d-flex gap-3'>
                                          <input
                                            className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                            type="text"
                                            placeholder="SubGala"
                                            {...register("sub_gala_name", {
                                              required: true,
                                              onChange: (e) => { e.target.value = e.target.value.toUpperCase() }
                                            })}
                                          />
                                        </div>
                                        <br />
                                      </td>
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </editable-table>
                            {areaerr &&
                              <ErrorComponents error={areaerr} />
                            }

                          </div>
                        </div>
                      </div>
                      :
                      <div className="bg-white py-2 px-3 rounded-5">
                        <h3 className="text-base-color fs-3 base-font-600">Please Select Ownership Type </h3>
                      </div>
                    :
                    investorNumber != 0 && selectednumber <= 10 && investorNumber != undefined ?
                      <div className="bg-white py-2 px-3 rounded-5">
                        <div>
                          <div className={`${userProject !== undefined ? "col-12 pb-3 pt-2" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                            <editable-table>
                              <table className=''>
                                <thead className=''>
                                  {(investorNumber != 0 && investorNumber != undefined) &&
                                    <tr >
                                      <th className='fs-5 col-3 title-font-600 mb-0 text-base-color'>
                                        Select Investor
                                      </th>
                                      <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                        Available Area
                                      </th>
                                      <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                        Sold Area
                                      </th>
                                      <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                        Sub-Gala Name
                                      </th>
                                    </tr>}
                                </thead>
                                <tbody>
                                  {(investorNumber != 0 && investorNumber != undefined) &&
                                    <>
                                      {investorNumber.map((number, i) => {
                                        return (
                                          <>
                                            <tr key={i}>
                                              <th scope="" style={{ display: "contents" }}>
                                                <td className=' pb-2 '>
                                                  <Controller
                                                    className="p-3 mb-3  border-radius-10 shadow-none  fs-4 title-font-500 fs-2 modal-input"
                                                    control={control}
                                                    name={`Investors_${number}`}
                                                    rules={{ required: true }}
                                                    render={({
                                                      field: { onChange },
                                                      fieldState: { isTouched, isDirty, error },
                                                      formState,
                                                    }) => (
                                                      <AsyncSelect placeholder="Investor" cacheOptions defaultOptions={investorList} loadOptions={InvestorOptions} onChange={onChange} className='w-100' />
                                                    )}
                                                  />
                                                </td>
                                                <td className=' pb-2 ps-1'>
                                                  <input
                                                    className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    min="0"
                                                    type="number"
                                                    placeholder="Area...."
                                                    disabled
                                                    {...register(`available_area_${number}`)}
                                                  />
                                                </td>
                                                <td className=' pb-2 ps-1'>
                                                  <input
                                                    className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                    min="0"
                                                    type="number"
                                                    step="any"
                                                    placeholder="Area...."
                                                    {...register(`sold_gala_area_${number}`, {
                                                      required: true,
                                                      onChange: (e) => {
                                                        CheckArea(e.target.value, number)
                                                      }, onBlur: (e) => {
                                                        GalaArea(e.target.value, number, true); CheckArea(e.target.value, number);
                                                      }
                                                    })}
                                                  />
                                                </td>
                                                <td className=' pb-2 ps-1'>
                                                  <input
                                                    className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 text-uppercase fs-2 modal-input"
                                                    type="text"
                                                    placeholder="Sub Gala."
                                                    {...register(`sub_gala_name_${number}`, {
                                                      required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() }, onBlur: () => { setValue('hidden', Number(count) + 1) }
                                                    })}
                                                  />
                                                </td>
                                              </th>
                                            </tr>
                                          </>
                                        )
                                      })}
                                    </>
                                  }
                                </tbody>
                              </table>
                            </editable-table>
                            {areaerr && <ErrorComponents error={areaerr} />}
                          </div>
                        </div>
                      </div>
                      :
                      <div className="bg-white py-3 px-5 rounded-5 text-center">
                        <h3 className="text-base-color fs-3 base-font-600">Please Select Ownership Type </h3>
                      </div>
                }
                {/* {sellError && <ErrorComponents error={sellError} />} */}
              </>
              }

            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
              onClick={CancelButton}
            >
              <span className="fs-4 d-flex gap-3 title-font-600 px-3">
                Cancel
              </span>
            </Button>{" "}
            <Button
              className="border-radius-7 p-3 d-flex align-items-center buttons"
              disabled={btndis || err}
            >
              <span className="fs-4 d-flex gap-3 title-font-600 px-3">Resell</span>
            </Button>
          </ModalFooter>
        </Form>
      </Modal >
    </>
  );
}

export default ResellGalasModal;